/**
 * Storage keys for Business Mappings listing filters
 */
export enum BusinessMappingFilterStorageKeys {
  // Travel Mappings
  EXPENSE_TYPE_LIMIT = 'businessMapping_expenseTypeLimit_filters',
  EXPENSE_ANTI_PATTERN = 'businessMapping_expenseAntiPattern_filters',
  PER_KM = 'businessMapping_perKm_filters',
  DEPARTMENT_COST_CENTER = 'businessMapping_departmentCostCenter_filters',
  COUNTRY_CITY = 'businessMapping_countryCity_filters',
  HANDSET = 'businessMapping_handset_filters',
  CONVEYANCE_LIMIT = 'businessMapping_conveyanceLimit_filters',
  TRAVEL_CALENDAR_RESTRICTION = 'businessMapping_travelCalendarRestriction_filters',
  CLAIM_SUB_CLAIM = 'businessMapping_claimSubClaim_filters',
  TRAVEL_APPROVAL = 'businessMapping_travelApproval_filters',
  TRAVEL_FORM_FIELD = 'businessMapping_travelFormField_filters',

  // Contract (IOM) Mappings
  CONTRACT_UNIVERSAL_FIELD_SET = 'businessMapping_contractUniversalFieldSet_filters',
  CONTRACT_APPROVAL = 'businessMapping_contractApproval_filters',

  // Activity Mappings
  ACTIVITY_APPROVAL = 'businessMapping_activityApproval_filters',

  // Sales Order (SO) Mappings
  SALES_ORDER_UNIVERSAL_FIELD_SET = 'businessMapping_salesOrderUniversalFieldSet_filters',
  TAX_CODE = 'businessMapping_taxCode_filters',
  EXCHANGE_RATE = 'businessMapping_exchangeRate_filters',
  CUSTOMER_MATERIAL = 'businessMapping_customerMaterial_filters',
  SALES_ORDER_APPROVAL = 'businessMapping_salesOrderApproval_filters',
  SALES_ORDER_FORM_FIELD = 'businessMapping_salesOrderFormField_filters',
  WAREHOUSE_VEHICLE_TYPE = 'businessMapping_warehouseVehicleType_filters',
}

/**
 * Retrieve saved filters from sessionStorage with fallback to defaults.
 */
export function getSavedFilters<T>(storageKey: string, defaultFilters: T): T {
  try {
    const saved = sessionStorage.getItem(storageKey);
    if (!saved) return defaultFilters;
    const parsed = JSON.parse(saved);
    return {
      ...defaultFilters,
      ...parsed,
    };
  } catch (error) {
    console.error(`Error parsing saved filters for key "${storageKey}":`, error);
    return defaultFilters;
  }
}

/**
 * Save current filters to sessionStorage.
 */
export function saveFilters<T>(storageKey: string, filters: T): void {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(filters));
  } catch (error) {
    console.error(`Error saving filters for key "${storageKey}":`, error);
  }
}

/**
 * Remove saved filters from sessionStorage on clear/reset.
 */
export function clearSavedFilters(storageKey: string): void {
  try {
    sessionStorage.removeItem(storageKey);
  } catch (error) {
    console.error(`Error removing filters for key "${storageKey}":`, error);
  }
}
